import React, { useState } from 'react';
import { ArrowRightIcon, DoorOpenIcon, InfoIcon, SlidersHorizontalIcon, SproutIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueCard } from '../story/DialogueCard';
import { ChipGroup } from '../story/ChipGroup';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { SceneIllustration } from '../art/SceneIllustration';
import { BridgeArt } from '../art/BridgeArt';
import { seedOptions } from '../../data/savanna';
export function BridgeScreen() {
  const {
    state,
    dispatch,
    openDialog,
    announce
  } = useDemo();
  const planted = state.seed !== null;
  const [choosing, setChoosing] = useState(false);
  const [learnMore, setLearnMore] = useState(false);
  const seedLabel = seedOptions.find(option => option.id === state.seed)?.label;
  const description = planted ? 'A small green leaf has opened above the dark soil. The green-gold root line below it now glows.' : 'A seed rests in dark soil. A green-gold root line waits beneath it.';
  return <ScreenContainer data-id="element-100" data-mp="28qgaiffzwuvh">
      <div className="grid gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-start" data-id="element-101" data-mp="28qy1oxnswiwj">
        <SceneIllustration description={description} quietTitle="Time-Bridge" data-id="element-102" data-mp="23rd4aroa4ilx">
          <BridgeArt planted={planted} seed={state.seed} label={description} data-id="element-103" data-mp="23tg3a17etm2s" />
        </SceneIllustration>
        <div data-id="element-104" data-mp="1g3va6phjl8fs">
          <ScreenHeading eyebrow="The Time-Bridge" data-id="element-105" data-mp="1b2o18n3ny37j">A seed in dark soil</ScreenHeading>
          <div className="mt-5 flex flex-col gap-3" data-id="element-106" data-mp="1b50q7k7u9du3">
            <DialogueCard line={{
            kind: 'speech',
            speaker: 'Wren',
            text: 'Every Bridge path starts with a seed. You do not need to know what it will become yet.'
          }} data-id="element-107" data-mp="1p3i7p075hu3k" />
            {planted && <div className="anim-enter flex flex-col gap-3" data-id="element-108" data-mp="2wgsfpijuwdid">
                <p data-id="element-109" data-mp="2wid74zavjgc0">
                  You planted the seed{seedLabel && state.seed !== 'blank' ? ` with: ${seedLabel}` : ''}. A small leaf
                  opens.
                </p>
                <DialogueCard line={{
              kind: 'speech',
              speaker: 'Wren',
              text: 'This is not a score. Small starts still count.'
            }} data-id="element-110" data-mp="1y6ar51k7svh9" />
              </div>}
          </div>

          {!planted && !choosing && <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-111" data-mp="1aelsz4kppcse">
              <Button onClick={() => setChoosing(true)} icon={<SproutIcon size={18} aria-hidden="true" data-id="element-113" data-mp="1fdgkqw0nqbon" />} data-id="element-112" data-mp="1ag6p2ymod3sd">
                Plant the seed
              </Button>
              <Button variant="secondary" onClick={() => openDialog('settings')} icon={<SlidersHorizontalIcon size={18} aria-hidden="true" data-id="element-115" data-mp="1o71we6hizctu" />} data-id="element-114" data-mp="1jes4wm0ri4pg">
                Access settings
              </Button>
              <Button variant="secondary" aria-expanded={learnMore} onClick={() => setLearnMore(value => !value)} icon={<InfoIcon size={18} aria-hidden="true" data-id="element-117" data-mp="o5ogq5odm7di" />} data-id="element-116" data-mp="rmb5oj2jjnfe">
                Learn more
              </Button>
              <Button variant="secondary" onClick={() => dispatch({
            type: 'LEAVE'
          })} icon={<DoorOpenIcon size={18} aria-hidden="true" data-id="element-119" data-mp="a6p2zt2ejcw4" />} data-id="element-118" data-mp="j50pbiw8joir">
                Leave for now
              </Button>
            </div>}

          {learnMore && !planted && !choosing && <p className="anim-enter mt-4 rounded-2xl border border-line bg-sand p-5 hc-strong" data-id="element-120" data-mp="g3vfg4r2y12">
              You are a <strong data-id="element-121" data-mp="3rm5di8n4urw7">Signal Keeper</strong>. Notice. Check. Choose a safer next step. You can pause or keep your
              work blank.
            </p>}

          {choosing && !planted && <div className="anim-enter mt-6" data-id="element-122" data-mp="3il74td1r1w7a">
              <ChipGroup legend="What goes in with the seed?" options={seedOptions.map(option => option.label)} onSelect={label => {
            const option = seedOptions.find(item => item.label === label);
            if (!option) return;
            dispatch({
              type: 'PLANT_SEED',
              seed: option.id
            });
            announce('Seed planted. A small leaf opens.');
          }} data-id="element-123" data-mp="3iobjx5gr6ccq" />
            </div>}
        </div>
      </div>
      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-124" data-mp="ytrirbzjechf">
        {planted && <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'arrival'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-126" data-mp="ovbt7dg5rba1" />} data-id="element-125" data-mp="12v4rbtu0kts1">
            Enter Savanna City
          </Button>}
      </ActionRow>
    </ScreenContainer>;
}